module.exports = __webpack_public_path__ + "img/57.6e21c9f8.png";